import { Link } from 'react-router-dom';
import { articlesList } from '@/mocks/articles';

export default function BlogCards() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-4">
            Latest Guides &amp; Resources
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            Explore our collection of in-depth guides covering every aspect of VigorBuy Spreadsheet — from beginner tutorials to advanced category deep-dives and the latest 2026 updates.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articlesList.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="aspect-[8/5] overflow-hidden relative">
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent z-10"></div>
                <img
                  src={article.cardImage}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">{article.excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 whitespace-nowrap">
                    Read More
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group block rounded-2xl bg-primary-500 border border-primary-400 hover:bg-primary-600 transition-all duration-300 overflow-hidden cursor-pointer"
          >
            <div className="aspect-[8/5] overflow-hidden relative">
              <div className="absolute inset-0 bg-gradient-to-t from-primary-600/40 via-transparent to-transparent z-10"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20online%20shopping%20concept%20with%20organized%20product%20grid%20layout%20on%20warm%20cream%20background%2C%20minimalist%20ecommerce%20aesthetic%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%20style%2C%20neutral%20warm%20tones%2C%20inviting%20shopping%20experience&width=800&height=500&seq=blog-shop-cta-vb&orientation=landscape"
                alt="Shop All Products"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-2.5 py-1 rounded-full bg-white/20 text-white text-xs font-medium whitespace-nowrap">
                  Shop Now
                </span>
              </div>
              <h3 className="font-heading font-semibold text-base text-white mb-2 leading-snug">
                Explore All Products on kaspreadsheet.com
              </h3>
              <p className="text-sm text-white/80 leading-relaxed mb-4">
                Browse the complete product catalog with thousands of items across all 14 categories.
              </p>
              <div className="flex items-center gap-1 text-sm font-medium text-white whitespace-nowrap">
                Buy It Now
                <i className="ri-arrow-right-up-line"></i>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}